export default __webpack_public_path__ + "static/media/main_L_left_bg.644a6f4d.png";